module.exports = __webpack_public_path__ + "img/Logo-GroupeSER.1df25ee3.png";